import { ChevronDownIcon, ChevronUpIcon, SlidersHorizontalIcon } from 'lucide-react'
import React, { forwardRef } from 'react'

import { Button } from '../Button'

interface FilterButtonProps extends Omit<React.ComponentProps<typeof Button>, 'children'> {
  size?: 'large' | 'small'
  filtersCount?: number
  open?: boolean
}

export const FilterButton = forwardRef<HTMLButtonElement, FilterButtonProps>(({ filtersCount, open, ...props }, forwardedRef) => {
  return (
    <Button
      {...props}
      leftIcon={SlidersHorizontalIcon}
      ref={forwardedRef}
      rightIcon={open ? ChevronUpIcon : ChevronDownIcon}
    >
      {filtersCount && filtersCount > 0 ? `Filters (${filtersCount})` : 'Filters'}
    </Button>
  )
})
